var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7492 0.0628014C30.2492 0.219051 0.50546 12.1566 0.36796 12.2566C0.13671 12.4191 -0.0257905 12.8628 0.0242095 13.1566C0.11796 13.6378 0.0992096 13.6316 6.39921 16.6816C9.66171 18.2628 12.3555 19.5816 12.3867 19.6128C12.418 19.6441 13.7367 22.3378 15.318 25.6003C18.368 31.9003 18.3617 31.8816 18.843 31.9753C19.1367 32.0253 19.5805 31.8628 19.743 31.6316C19.9055 31.4066 31.8742 1.4878 31.9617 1.10655C32.018 0.837801 32.0117 0.775301 31.8867 0.537802C31.6555 0.106552 31.2055 -0.0809479 30.7492 0.0628014ZM19.9992 10.6566L12.9055 17.7503L8.10546 15.4253C4.76796 13.8066 3.33046 13.0753 3.38671 13.0378C3.49921 12.9691 26.9492 3.5753 27.0305 3.56905C27.0617 3.5628 23.8992 6.75655 19.9992 10.6566ZM23.7117 16.7878C21.1117 23.2816 18.968 28.6128 18.943 28.6378C18.918 28.6691 17.8555 26.5316 16.5742 23.8941L14.2492 19.0941L21.3242 12.0191C25.218 8.1253 28.4055 4.9503 28.418 4.9628C28.4242 4.96905 26.3117 10.2878 23.7117 16.7878Z",
    fill: "#004B86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/iconSend.159ef31d6ce27c038b84d83640992597.svg";
export { ForwardRef as ReactComponent };